module.exports = __webpack_public_path__ + "static/media/2015_conf_From_Story_to_Product_in_180_Days.18f76474.png";